"use client";

import React, { useId } from "react";
import FieldError from "../FieldError";

interface RadioGroupProps {
  legend: string;
  name: string;
  options: { value: string; label: string }[];
  required?: boolean;
  testId?: string;
  error?: string;
}

/**
 *
 * RadioGroup
 *
 */
const RadioGroup = ({
  legend,
  name,
  options,
  required = false,
  testId,
  error = "",
}: RadioGroupProps) => {
  const errorId = useId();

  return (
    <fieldset
      data-testid={testId}
      aria-describedby={error ? errorId : undefined}
      className="px-10 py-2"
    >
      <legend className="text-base sm:text-lg leading-snug mb-3">
        {legend}
        {required ? <span aria-hidden="true"> *</span> : null}
      </legend>
      <div className="flex items-center gap-8">
        {options.map((option) => (
          <label
            key={option.value}
            className="flex items-center gap-3 cursor-pointer text-base sm:text-lg"
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              required={required}
              aria-invalid={error ? true : undefined}
              className="w-5 h-5 cursor-pointer accent-current"
            />
            {option.label}
          </label>
        ))}
      </div>
      <FieldError id={errorId} message={error} inset={false} />
    </fieldset>
  );
};

export default RadioGroup;
